import React from "react";
import { useLang } from "@/contexts/LangContext";
import { ShieldAlert, AlertTriangle, Scale, Percent, Lock, Mail } from "lucide-react";

export default function Compliance() {
  const { t } = useLang();
  const sections = [
    { Icon: AlertTriangle, title: t("comp_s1_title"), body: t("comp_s1_body") },
    { Icon: ShieldAlert, title: t("comp_s2_title"), body: t("comp_s2_body") },
    { Icon: Percent, title: t("comp_s3_title"), body: t("comp_s3_body") },
    { Icon: Scale, title: t("comp_s4_title"), body: t("comp_s4_body") },
    { Icon: Lock, title: t("comp_s5_title"), body: t("comp_s5_body") },
  ];
  return (
    <div data-testid="compliance-page" className="max-w-[1000px] mx-auto px-6 py-12">
      <div className="text-[10px] uppercase tracking-widest text-[#FF3366] font-mono">Legal</div>
      <h1 className="font-display text-3xl md:text-5xl font-bold mt-2">{t("comp_title")}</h1>
      <p className="text-white/50 text-sm mt-4 max-w-2xl">{t("comp_intro")}</p>

      <div className="mt-10 space-y-px bg-[#222] border border-[#222]">
        {sections.map((s, i) => (
          <div key={i} className="bg-[#0A0A0A] p-6 md:p-8 flex items-start gap-4" data-testid={`compliance-section-${i}`}>
            <s.Icon size={20} className="text-[#FF3366] flex-shrink-0 mt-1" />
            <div>
              <div className="font-display text-lg font-bold">{s.title}</div>
              <p className="mt-2 text-white/60 text-sm leading-relaxed">{s.body}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-10 border border-[#222] p-6 flex items-center gap-3 text-sm text-white/60 font-mono">
        <Mail size={16} className="text-[#CCFF00]" /> {t("comp_contact")} : support@x1k.app
      </div>
    </div>
  );
}
